import Swiper from "swiper";
export function testimonialsSlider() {
    var testimonialsSwiper = new Swiper(".testimonial-slider", {
        loop: true,
        slidesPerView: 1,
        autoplay: {
            delay: 5000
        },
        navigation: {
            nextEl: '.testimonial-next',
            prevEl: '.testimonial-prev'
        }
    });

}
